export default __webpack_public_path__ + "static/media/TIFWNCBP.6acb133d.pdf";